export const states = {
  published: 'published',
  hidden: 'hidden',
}

export const choicesStates = [
  {
    id: states.published,
    name: 'Published',
  },
  {
    id: states.hidden,
    name: 'Hidden',
  },
]
